import CheckBox from '@app/components/CheckBox'
import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import { Chat, IChat } from '@app/models/Chat'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Column } from 'react-virtualized'
import { actionCreators, IMessagesListState } from '../modules/messagesList'
import './MessagesListPage.scss'

type ComponentProps = IMessagesListState &
  ICurrentUserState &
  typeof actionCreators

export default class AssignmentsListPage extends React.PureComponent<
  ComponentProps
> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public render() {
    const userId = this.props.user ? this.props.user.id : 0

    return (
      <DocumentTitle title='Messages'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>Messages</h3>
            <CheckBox
              onChange={(e) => {
                this.props.setShowArchived(e)
                this._reloadData()
              }}
              value={this.props.showArchived}
            >
              Show archived messages
            </CheckBox>
          </div>
          <div className='mt-4'>
            <InfiniteScrollTable
              isLoading={this.props.isLoading}
              items={this.props.items}
              rowHeight={60}
              loadItems={this.props.loadMessages}
              noRowsRenderer={this._noRowsRenderer}
              onRowClicked={this._onRowClicked}
              totalItems={this.props.totalItems}
              ref={this.tableRef}
            >
              <Column
                cellRenderer={({ rowData }) => {
                  const chat = rowData as IChat
                  return (
                    <div className='message-images-container'>
                      <div
                        className={`first-image ${
                          chat.group.size === 1
                            ? 'message-images-1'
                            : chat.group.size === 2
                            ? 'message-images-2'
                            : 'message-images-3'
                        }`}
                      >
                        <img
                          src={`/api/Contacts/${
                            chat.group.first().contactId
                          }/ProfileImage?h=50&w=50`}
                        />
                      </div>
                      {chat.group.size > 1 &&
                        chat.group.skip(1).first().contactId !== userId && (
                          <div
                            className={`second-image ${
                              chat.group.size === 1
                                ? 'message-images-1'
                                : chat.group.size === 2
                                ? 'message-images-2'
                                : 'message-images-3'
                            }`}
                          >
                            <img
                              src={`/api/Contacts/${
                                chat.group.skip(1).first().contactId
                              }/ProfileImage?h=50&w=50`}
                            />
                          </div>
                        )}
                      {chat.group.size > 2 && (
                        <div
                          className={`third-image ${
                            chat.group.size === 1
                              ? 'message-images-1'
                              : chat.group.size === 2
                              ? 'message-images-2'
                              : 'message-images-3'
                          }`}
                        >
                          <img
                            src={`/api/Contacts/${
                              chat.group.skip(2).first().contactId
                            }/ProfileImage?h=50&w=50`}
                          />
                        </div>
                      )}
                    </div>
                  )
                }}
                dataKey='images'
                width={80}
              />
              <Column
                cellRenderer={({ rowData }) => {
                  const chat = rowData as IChat
                  return (
                    <div>
                      <div
                        className='overflow-text'
                        style={{ fontWeight: 'bold' }}
                      >
                        {Chat.getRecipientList(chat, this.props.user)}
                        {this.getIsArchived(chat) && (
                          <strong>
                            <span
                              style={{ color: '#D33921', fontSize: '13px' }}
                            >
                              {' '}
                              (ARCHIVED)
                            </span>
                          </strong>
                        )}
                      </div>
                      <div className='overflow-text'>
                        {chat.messages.last().text}
                      </div>
                    </div>
                  )
                }}
                dataKey='message'
                flexGrow={1}
                width={100}
              />
              <Column
                cellRenderer={({ rowData }) => {
                  const chat = rowData as IChat
                  return (
                    <div
                      onClick={(e) => {
                        // clicked delete message
                      }}
                    >
                      <FontAwesomeIcon
                        icon={['fal', 'trash']}
                        color='#D33921'
                      />
                    </div>
                  )
                }}
                dataKey='deleteButton'
                width={30}
              />
            </InfiniteScrollTable>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private getIsArchived(chat: IChat) {
    if (chat.deleted) {
      return true
    }

    if (this.props.user && chat.hasArchived.indexOf(this.props.user.id) > -1) {
      return true
    }

    return false
  }

  private _noRowsRenderer() {
    return <div>No goals</div>
  }

  private _onRowClicked(item: IChat, index: number) {
    window.alert(`Clicked on ${item.messages.last().text}`)
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
